import { connect } from 'react-redux';
import { compose } from 'recompose';

import WellTable from './WellTable';
import {
  openWellEditModal,
  openWellMergeModal,
  closeWellMergeModal,
  closeWellEditModal,
} from '../actions';
import {
  getSelectedWell,
  getWellEditModal,
  getWellMergeModal,
} from '../selectors';
import { enableLookupFeature } from '../../../configuration/selectors';

import { queryWellGQL } from '../graphql';

const mapStateToProps = (state) => {
  return {
    selectedWell: getSelectedWell(state),
    showWellEntryModal: getWellEditModal(state),
    showWellMergeModal: getWellMergeModal(state),
    enableLookupFeature: enableLookupFeature(state),
  };
};

const mapDispatchToProps = {
  openWellEditModal,
  openWellMergeModal,
  closeWellMergeModal,
  closeWellEditModal,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  queryWellGQL,
  withRedux,
);

export default enhance(WellTable);
